import type { JobModuleTriggerCardTitleProps } from "./job-module-trigger-card-title.type";

import { Flex, Tooltip } from "antd";

import JobModuleIcon from "@/modules/job-module/job-module-icon";
import JobModuleOutcomeTags from "@/modules/job-module/job-module-outcome-tags";

import "./job-module-trigger-card-title.style.less";

const JobModuleTriggerCardTitle = ({
  module,
}: JobModuleTriggerCardTitleProps) => {
  return (
    <div className="job-module-trigger-card-title">
      <JobModuleOutcomeTags module={module} />
      <Tooltip title={module?.description}>
        <Flex align="center" gap="small">
          <JobModuleIcon iconName={module.icon ?? null} />
          {module?.name}
        </Flex>
      </Tooltip>
    </div>
  );
};

export default JobModuleTriggerCardTitle;
